module.exports = __webpack_public_path__ + "images/旅悦好物全景_02-2.jpg?v=b3765e17";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_02-2.jpg
 ** module id = 129
 ** module chunks = 1 2
 **/